// extracted by mini-css-extract-plugin
export default {"field":"CourierAddressForm_field__gxdIK","title":"CourierAddressForm_title__mm1rw"};